import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { authenticatedUser } from 'header-scripts';
import WidgetContainer from './WidgetContainer';
import PremiumTitle from '../components/PremiumTitle';
import StipendSection from '../components/StipendSection';
import CatalogBenefitSection from '../components/CatalogBenefitSection';
import GameBenefitSection from '../components/GameBenefitSection';
import DiscountAndTrade from '../components/DiscountAndTrade';
import SubscriptionCardContainer from './SubscriptionCardContainer';
import PremiumConstants from '../constants/PremiumConstants';
import PremiumService from '../services/premiumService';

function SubscriptionPageBase({ translate, intl }) {
  const containerBaseRef = useRef(null);
  const [subProducts, setSubProducts] = useState(null);

  const { isPremiumUser } = authenticatedUser;
  function showError(error) {
    console.log(error);
  }

  function getSearchParams() {
    const queryParams = new Map();
    window.location.search
      .substr(1)
      .split('&')
      .forEach(function parseQuery(query) {
        const param = query.split('=');
        const key = param[0];
        let value = decodeURIComponent(param[1]);
        value = Number.isNaN(Number(value)) ? value : Number(value);
        queryParams.set(key, value);
      });
    return queryParams;
  }

  useEffect(() => {
    function feedProducts(oldProducts) {
      if (!oldProducts || oldProducts.length <= 0) {
        return;
      }

      const newProducts = [];
      oldProducts.forEach(product => {
        const tempProduct = { ...product };
        tempProduct.isRecurring =
          product.subscriptionTypeName.toLowerCase().indexOf('onemonth') < 0;
        newProducts.push(tempProduct);
      });
      setSubProducts(newProducts);
    }

    PremiumService.getSubscriptionPlans({
      typeName: PremiumConstants.premiumFeatureType.subscription
    }).then(
      result => {
        if (result?.data) {
          feedProducts(result.data.products);
        } else {
          showError({ errorCode: PremiumConstants.errorCodes.productsNotFound });
        }
      },
      error => {
        showError(error);
      }
    );
  }, []);

  useEffect(() => {
    if (isPremiumUser) {
      const pageElement = document.getElementById('premium-memberships');
      pageElement.scrollIntoView({ behavior: 'smooth' });
    }
  }, [isPremiumUser]);

  return (
    <div
      className='subscription-container-base'
      id='subscription-container-base'
      ref={containerBaseRef}>
      <WidgetContainer translate={translate} />
      <PremiumTitle translate={translate} isPremiumUser={isPremiumUser} id='premium-title' />
      <StipendSection translate={translate} planInfo={subProducts} />
      <CatalogBenefitSection translate={translate} />
      <GameBenefitSection translate={translate} />
      <DiscountAndTrade translate={translate} />
      <SubscriptionCardContainer translate={translate} intl={intl} planInfo={subProducts} />
    </div>
  );
}
SubscriptionPageBase.propTypes = {
  translate: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    d: PropTypes.func.isRequired
  }).isRequired
};
export default SubscriptionPageBase;
